import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ListColumnConfigg } from '../../../core/models/list-column-config.model';
import { ListConfigService } from '../../../core/services/list-config.service';

@Component({
      selector: 'app-list-config-manager',
      standalone: true,
      imports: [CommonModule, FormsModule],
      templateUrl: './metalist-manager.component.html'
})
export class ListConfigComponent implements OnInit {

      // Pagination Variables
      pageIndex = 0;
      pageSize = 10;
      total = 0;

      configs: ListColumnConfigg[] = [];
      filteredConfigs: ListColumnConfigg[] = [];
      searchTerm = '';


      isModalOpen = false;
      isEditMode = false;

      current: ListColumnConfigg = this.getEmpty();

      constructor(private service: ListConfigService) { }

      ngOnInit() {
            this.load();
      }


      get totalPages() {
            return Math.ceil(this.total / this.pageSize);
      }

      get paginatedConfigs() {
            const start = this.pageIndex * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredConfigs.slice(start, end);
      }

      getEmpty(): ListColumnConfigg {
            return {
                  id: undefined,
                  field: '',
                  label: '',
                  entity: '',
                  isVisible: true,
                  valueSource: 'static',
                  isSortable: true,
                  width: 160,
                  seq: 0,
                  filterType: null,
                  relationEntity: null,
                  relationField: null
            };
      }

      load() {
            this.service.getAll(this.pageIndex, this.pageSize, this.searchTerm)
                  .subscribe({
                        next: (res) => {
                              this.configs = res?.items ?? [];
                              this.total = res?.totalCount ?? 0;
                              // ADD THIS LINE:
                              this.filteredConfigs = [...this.configs];
                        },
                        error: (err) => {
                              console.error("Load failed", err);
                              this.configs = [];
                              this.filteredConfigs = [];
                        }
                  });
      }
      onSearch() {
            this.pageIndex = 0; // Reset to page 1
            this.load();
      }


      filter() {
            const term = this.searchTerm.toLowerCase();
            this.filteredConfigs = this.configs.filter(c =>
                  c.field.toLowerCase().includes(term) ||
                  c.label.toLowerCase().includes(term)
            );
            this.pageIndex = 0; // Reset to first page on search

      }
      goToPage(index: number) {
            this.pageIndex = index;
            this.load(); // Refresh data from server for the new page
      }

      changePageSize(event: any) {
            this.pageSize = +event.target.value;
            this.pageIndex = 0;
            this.load(); // Refresh data with new page size
      }

      openCreate() {
            this.isEditMode = false;
            this.current = this.getEmpty();
            this.isModalOpen = true;
      }

      openEdit(cfg: ListColumnConfigg) {
            this.isEditMode = true;
            this.current = { ...cfg };
            this.isModalOpen = true;
      }

      close() {
            this.isModalOpen = false;
      }

      save() {
            // 1. Create a copy of the data so we don't mess up the UI
            const payload = { ...this.current };

            if (this.isEditMode && payload.id) {
                  // UPDATE MODE
                  this.service.update(payload).subscribe(() => {
                        this.afterSave();
                  });
            } else {
                  // CREATE MODE
                  // 2. IMPORTANT: Remove the ID entirely so the DB generates a new one
                  delete payload.id;

                  this.service.create(payload).subscribe(() => {
                        this.afterSave();
                  });
            }
      }

      // Helper to refresh UI
      afterSave() {
            this.close();
            this.load();
      }

      delete(id?: number) {
            if (!id) return;
            if (confirm('Delete this column config?')) {
                  this.service.delete(id).subscribe(() => this.load());
            }
      }

}
